import { Box, styled } from "@mui/material";
import { Link as RouterLink } from "react-router";
import { DiscoverCardActionArea } from "./discover-card-action-area";
import { MomentContent } from "./discover-card-content";
import { MomentImage } from "./discover-card-image";

import type { BrandInfoSelected } from "../../brand-kit/types";
import type { DiscoverTemplate } from "../types";
import type { CardProps } from "@mui/material";
import type { FC, ReactNode } from "react";
import type { To } from "react-router";

interface DiscoverTemplateCardProps extends Omit<CardProps, "onClick"> {
  template: DiscoverTemplate;
  onClick?: (e: React.MouseEvent<HTMLDivElement>, template: DiscoverTemplate) => void;
  brandKitSelections?: BrandInfoSelected;
  badge?: ReactNode;
  subheadingGetter?: (t: DiscoverTemplate) => string | null;
  /** Makes the card a link to the template, so it can be opened in a new tab. */
  to?: To;
}

const CardContent = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  flexGrow: 1,
  width: "100%",
  transition: "padding .3s ease-in-out",
  className: "Card-content",
}));

export const DiscoverCard: FC<DiscoverTemplateCardProps> = ({
  template,
  onClick,
  brandKitSelections,
  badge,
  subheadingGetter,
  to,
  ...boxProps
}) => {
  const handleClick = (e: React.MouseEvent<HTMLDivElement>): void => {
    onClick?.(e, template);
  };

  return (
    <Box
      {...boxProps}
      onClick={handleClick}
      sx={[
        { maxWidth: "320px", overflow: "visible" },
        ...(Array.isArray(boxProps.sx) ? boxProps.sx : [boxProps.sx]),
      ]}
    >
      <DiscoverCardActionArea
        {...(to && { component: RouterLink, to })}
        sx={{ color: "inherit", textDecoration: "none" }}
      >
        <Box sx={{ position: "relative", width: "100%", paddingBottom: "100%", flexGrow: 0 }}>
          {badge}
          <MomentImage template={template} brandKitSelections={brandKitSelections} />
        </Box>
        <CardContent className="Card-content">
          <MomentContent template={template} subheadingGetter={subheadingGetter} />
        </CardContent>
      </DiscoverCardActionArea>
    </Box>
  );
};
